module.exports = __webpack_public_path__ + "img/extraversion-arrow.92938cc5.svg";